import React from 'react';
import ProfileWizard from '../components/profile/ProfileWizard';

const InvestorProfilePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark-950">
      <ProfileWizard userType="investor" />
    </div>
  );
};

export default InvestorProfilePage;
